<template>
  <div class="withdraw-page">
    <!-- 导航栏 -->
    <div class="nav-header">
      <div class="nav-back" @click="back">
        <van-icon name="arrow-left" />
      </div>
      <div class="nav-title">{{$t('withdraw.title')}}</div>
      <div class="nav-right" @click="$router.push('/WithdrawRecord')">
        {{$t('withdraw.log')}}
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content">
      <!-- 提现方式选择 -->
      <div class="card" @click="showBankPicker = true">
        <div class="card-label">{{$t('withdraw.method')}}</div>
        <div class="bank-display">
          <span class="bank-text">{{ selectedBankText || $t('withdraw.selectBankCard') }}</span>
          <van-icon name="arrow-down" class="bank-arrow" />
        </div>
      </div>

      <!-- 提现金额 -->
      <div class="card">
        <div class="card-label">{{$t('withdraw.title')}} (KRW)</div>
        <div class="amount-input">
          <div class="currency">KRW</div>
          <input 
            v-model="withdraw_money" 
            :placeholder="$t('withdraw.avmoney') + userInfo.money"
            type="number"
            class="amount-field"
          />
          <div class="all-btn" @click="allMoeny">
            {{$t('common.all')}}
          </div>
        </div>
        
        <!-- 余额和限额信息 -->
        <div class="balance-info">
          <div class="balance">
            {{$t('withdraw.avmoney')}}：
            <span class="balance-amount">{{ userInfo.money }} KRW</span>
          </div>
          <div class="limit-info" @click="showPopover = true">
            <van-icon name="question-o" />
            {{$t('withdraw.limit')}}
          </div>
        </div>
      </div>

      <!-- 提交按钮 -->
      <button class="submit-btn" @click="doWithdraw">
        {{$t('withdraw.submit')}}
      </button>
    </div>

    <!-- 国际化银行卡选择器 -->
    <van-action-sheet 
      v-model="showBankPicker" 
      :title="$t('withdraw.selectBankCard')"
      class="bank-action-sheet"
    >
      <div class="bank-list">
        <div
          v-for="bank in banklist"
          :key="bank.value"
          class="bank-item"
          :class="{ 'bank-item--selected': value1 === bank.value }"
          @click="selectBank(bank)"
        >
          <div class="bank-item-content">
            <div class="bank-icon">
              <van-icon name="credit-pay" />
            </div>
            <div class="bank-info">
              <div class="bank-name">{{ bank.text }}</div>
              <div class="bank-desc" v-if="bank.desc">{{ bank.desc }}</div>
            </div>
            <div class="bank-check" v-if="value1 === bank.value">
              <van-icon name="success" />
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>

    <!-- 或者使用 Picker 组件的国际化版本 -->
    <van-popup 
      v-model="showBankPicker2" 
      position="bottom" 
      round
      class="bank-picker-popup"
    >
      <van-picker
        :title="$t('withdraw.selectBankCard')"
        show-toolbar
        :columns="bankColumns"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="onBankConfirm"
        @cancel="showBankPicker2 = false"
      />
    </van-popup>

    <!-- 限额说明弹窗 -->
    <van-popover v-model="showPopover" placement="top">
      <div class="limit-popover">
        <p>1. {{$t('singleLimit')}}: {{$t('lowest')}} 100.00KRW, {{$t('highest')}} 1000000.00KRW</p>
        <p>2. {{$t('maxDailyWithdraw')}}: 10000000.00KRW</p>
        <p>3. {{$t('withdrawTimes')}}: 1{{$t('common.minenav')}} {{$t('maxDailyWithdraw')}} 999{{$t('times')}}({{$t('withdraw.title')}} {{$t('times')}} 500{{$t('times')}})</p>
        <p>4. {{$t('arrivalTime')}} {{$t('timedetail')}}</p>
      </div>
    </van-popover>

    <!-- 支付密码弹窗 -->
    <van-dialog
      v-model="showDialog"
      :title="$t('setting.paypwdtitle')"
      :confirm-button-text="$t('common.confirm')"
      :cancel-button-text="$t('common.cancel')"
      show-cancel-button
      @confirm="onConfirm"
      @cancel="showDialog = false"
    >
      <van-field
        v-model="paypsd"
        ref="inputField"
        type="password"
        :label="$t('setting.paypwd')"
        :placeholder="$t('withdraw.enterPayPassword')"
        class="password-field"
      />
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'WithdrawPage',
  data() {
    return {
      showDialog: false,
      paypsd: '',
      showPopover: false,
      showBankPicker: false,
      showBankPicker2: false,
      withdraw_money: "",
      userInfo: {},
      value1: 0,
      banklist: [
        { text: this.$t('withdraw.bank'), value: 0, desc: this.$t('withdraw.bankDesc') }
      ],
      bankColumns: [],
      withdrawRole: {}
    };
  },
  computed: {
    selectedBankText() {
      if (!this.value1) return '';
      const selected = this.banklist.find(item => item.value === this.value1);
      return selected ? selected.text : '';
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    
    selectBank(bank) {
      this.value1 = bank.value;
      this.showBankPicker = false;
    },
    
    onBankConfirm(value) {
      const selectedBank = this.banklist.find(item => item.text === value);
      if (selectedBank) {
        this.value1 = selectedBank.value;
      }
      this.showBankPicker2 = false;
    },
    
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    
    getUserWithdrawRole() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res => {
        if (res.code === 200) {
          this.withdrawRole = res.data.data;
          // 格式化银行列表数据
          const additionalBanks = res.data.list.map(bank => ({
            ...bank,
            desc: this.$t('withdraw.bankCardDesc')
          }));
          this.banklist = this.banklist.concat(additionalBanks);
          this.bankColumns = this.banklist.map(item => item.text);
          // 设置默认选择第一个银行卡
          if (this.banklist.length > 0) {
            this.value1 = this.banklist[0].value;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    
    allMoeny() {
      this.withdraw_money = this.userInfo.money;
    },
    
    doWithdraw() {
      if (this.withdraw_money <= 0) {
        this.$toast(this.$t('withdraw.enterCorrectAmount'));
        return false;
      } else if (this.value1 == 0) {
        this.$toast(this.$t('withdraw.selectBankCard'));
        return false;
      } else {
        this.showDialog = true;
      }
    },
    
    onConfirm() {
      if (this.paypsd == '') {
        this.$toast(this.$t('withdraw.enterPayPassword'));
        return false;
      } else {
        this.$http({
          method: 'post',
          data: { password: this.paypsd },
          url: 'user_check_paypw'
        }).then(res => {
          if (res.code === 200) {
            this.dosubmit();
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        });
      }
    },
    
    dosubmit() {
      this.$http({
        method: 'post',
        data: { money: this.withdraw_money, bankid: this.value1 },
        url: 'user_set_withdraw'
      }).then(res => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          setTimeout(() => {
            this.$router.push('/Mine');
          }, 1500);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/Login');
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style lang="less" scoped>
.withdraw-page {
  min-height: 100vh;
  background: #f5f6fa;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  font-size: 26px;
}

/* 导航栏 */
.nav-header {
  height: 80px;
  background: linear-gradient(135deg, #8e44ad 0%, #3498db 100%);
  display: flex;
  align-items: center;
  padding: 0 24px;
  position: relative;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}

.nav-back {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .van-icon {
    font-size: 32px;
    color: #fff;
  }
}

.nav-title {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 600;
}

.nav-right {
  color: #fff;
  font-size: 24px;
  font-weight: 500;
  padding: 12px 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.2);
}

/* 内容区域 */
.content {
  padding: 32px 24px;
}

/* 卡片样式 */
.card {
  background: #fff;
  border: 2px solid #e8e8e8;
  border-radius: 20px;
  margin-bottom: 24px;
  padding: 28px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  
  &:active {
    background: #f8f9ff;
    border-color: #667eea;
  }
}

.card-label {
  font-size: 26px;
  color: #333;
  font-weight: 600;
  margin-bottom: 20px;
}

/* 银行卡选择显示 */
.bank-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
}

.bank-text {
  font-size: 26px;
  color: #333;
  
  &:empty::before {
    content: attr(data-placeholder);
    color: #999;
    font-size: 26px;
  }
}

.bank-arrow {
  font-size: 26px;
  color: #999;
}

/* 金额输入 */
.amount-input {
  display: flex;
  align-items: center;
  background: #f8f9ff;
  border-radius: 16px;
  padding: 0 20px;
  margin-bottom: 20px;
  border: 2px solid #e8e8e8;
}

.currency {
  font-size: 26px;
  color: #667eea;
  font-weight: 600;
  margin-right: 16px;
}

.amount-field {
  flex: 1;
  border: none;
  background: transparent;
  padding: 20px 0;
  font-size: 26px;
  color: #333;
  outline: none;
  
  &::placeholder {
    color: #999;
    font-size: 24px;
  }
}

.all-btn {
  font-size: 24px;
  color: #667eea;
  font-weight: 600;
  padding: 12px 16px;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 12px;
  cursor: pointer;
}

/* 余额信息 */
.balance-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 2px solid #f0f0f0;
}

.balance {
  font-size: 24px;
  color: #666;
}

.balance-amount {
  color: #667eea;
  font-weight: 600;
}

.limit-info {
  display: flex;
  align-items: center;
  font-size: 22px;
  color: #667eea;
  cursor: pointer;
  
  .van-icon {
    margin-right: 8px;
    font-size: 24px;
  }
}

/* 国际化银行卡选择器样式 */
::v-deep .bank-action-sheet {
  .van-action-sheet__header {
    font-size: 26px;
    font-weight: 600;
    padding: 24px 20px;
  }
  
  .van-action-sheet__content {
    max-height: 60vh;
    overflow-y: auto;
  }
}

.bank-list {
  padding: 0 20px 20px;
}

.bank-item {
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
  }
  
  &--selected {
    .bank-name {
      color: #667eea;
    }
    
    .bank-check {
      color: #667eea;
    }
  }
}

.bank-item-content {
  display: flex;
  align-items: center;
}

.bank-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #3498db, #8e44ad);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  
  .van-icon {
    font-size: 24px;
    color: #fff;
  }
}

.bank-info {
  flex: 1;
}

.bank-name {
  font-size: 26px;
  color: #333;
  font-weight: 500;
  margin-bottom: 4px;
}

.bank-desc {
  font-size: 22px;
  color: #999;
}

.bank-check {
  .van-icon {
    font-size: 28px;
    color: #ccc;
  }
}

/* Picker 选择器样式 */
::v-deep .bank-picker-popup {
  .van-picker {
    background: #fff;
    
    .van-picker__toolbar {
      height: 80px;
      border-bottom: 2px solid #f0f0f0;
    }
    
    .van-picker__confirm,
    .van-picker__cancel {
      font-size: 26px;
      color: #667eea;
      padding: 0 28px;
    }
    
    .van-picker__title {
      font-size: 26px;
      color: #333;
      font-weight: 500;
    }
    
    .van-picker-column__item {
      font-size: 26px;
      color: #333;
      height: 80px;
      line-height: 80px;
    }
    
    .van-picker-column__item--selected {
      color: #667eea;
      font-weight: 500;
      font-size: 28px;
    }
  }
}

/* 限额说明弹窗 */
.limit-popover {
  padding: 20px;
  max-width: 400px;
  
  p {
    font-size: 22px;
    color: #333;
    line-height: 1.5;
    margin-bottom: 12px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

/* 提交按钮 */
.submit-btn {
  width: 100%;
  height: 80px;
  background: linear-gradient(135deg, #8e44ad 0%, #3498db 100%);
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 28px;
  font-weight: 600;
  margin-top: 32px;
  box-shadow: 0 6px 25px rgba(102, 126, 234, 0.3);
  transition: all 0.2s ease;
  
  &:active {
    transform: scale(0.98);
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
  }
}

/* 响应式适配 */
@media (max-width: 375px) {
  .withdraw-page {
    font-size: 24px;
  }
  
  .content {
    padding: 28px 20px;
  }
  
  .card {
    padding: 24px;
    border-radius: 18px;
    margin-bottom: 20px;
  }
  
  .card-label {
    font-size: 24px;
  }
  
  .bank-text {
    font-size: 24px;
  }
  
  .amount-input {
    padding: 0 18px;
    border-radius: 14px;
  }
  
  .currency {
    font-size: 24px;
  }
  
  .amount-field {
    font-size: 24px;
    
    &::placeholder {
      font-size: 22px;
    }
  }
  
  .all-btn {
    font-size: 22px;
    padding: 10px 14px;
  }
  
  .submit-btn {
    height: 72px;
    font-size: 26px;
    border-radius: 18px;
  }
}

/* 动画效果 */
.card {
  animation: slideUp 0.4s ease-out forwards;
  opacity: 0;
  transform: translateY(20px);
  
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
}

.submit-btn {
  animation: slideUp 0.4s ease-out 0.3s forwards;
  opacity: 0;
  transform: translateY(20px);
}

@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 禁用文本选择 */
.withdraw-page {
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.amount-field {
  user-select: text;
}
</style>